import { UseFormSetError } from "react-hook-form";

type InvoiceCostFieldError = {
  title?: string;
  message?: string;
};

const COST_KEY_PATTERN = /^cost_(\d+)$/;

/**
 * Maps v4 invoice submit `costs.{section}.cost_{n}` errors onto react-hook-form fields
 * and returns de-duplicated user-facing messages for toasts.
 */
export const applyInvoiceSubmitServerErrors = (
  error: unknown,
  setError: UseFormSetError<any>,
): string[] => {
  const costs = (error as { response?: { data?: { costs?: Record<string, unknown> } } })?.response?.data
    ?.costs;
  if (!costs || typeof costs !== "object") {
    return [];
  }

  const messages: string[] = [];

  Object.entries(costs).forEach(([section, sectionErrors]) => {
    if (!sectionErrors || typeof sectionErrors !== "object") {
      return;
    }
    Object.entries(sectionErrors as Record<string, InvoiceCostFieldError[]>).forEach(([costKey, fieldErrors]) => {
      const match = COST_KEY_PATTERN.exec(costKey);
      if (!match || !Array.isArray(fieldErrors)) {
        return;
      }
      const costIndex = match[1];
      fieldErrors.forEach((fieldError) => {
        const message = fieldError?.message;
        if (!message) {
          return;
        }
        const label = fieldError?.title || section;
        setError(`costs.${section}.${costIndex}.invoiced_cost`, {
          type: "server",
          message,
        });
        messages.push(`${label}: ${message}`);
      });
    });
  });

  return [...new Set(messages)];
};
